var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosky(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "159.223 172.335 290.83 292.33",
    width: 290.83,
    height: 292.33,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 3.477036, -4.928929)",
    ry: 24,
    rx: 24,
    id: "svg_5",
    cy: 196.74999,
    cx: 284.13819,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#00ffff",
    fill: "#000000"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 7.726837, -4.909296)",
    ry: 24,
    rx: 24,
    id: "svg_6",
    cy: 440.24921,
    cx: 285.13818,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#00ffff",
    fill: "#000000"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 7.554096, -6.115107)",
    ry: 24,
    rx: 24,
    id: "svg_7",
    cy: 429.74925,
    cx: 354.13796,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#00ffff",
    fill: "#000000"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 6.785462, -7.038133)",
    ry: 24,
    rx: 24,
    id: "svg_8",
    cy: 385.24939,
    cx: 406.6378,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#00ffff",
    fill: "#000000"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 5.610322, -7.380008)",
    ry: 24,
    rx: 24,
    id: "svg_9",
    cy: 317.7496,
    cx: 425.63773,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#00ffff",
    fill: "#000000"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 4.455421, -7.041013)",
    ry: 24,
    rx: 24,
    id: "svg_10",
    cy: 251.74981,
    cx: 405.6378,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#00ffff",
    fill: "#000000"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 7.219849, -3.814138)",
    ry: 24,
    rx: 24,
    id: "svg_11",
    cy: 411.7493,
    cx: 222.13838,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#00ffff",
    fill: "#000000"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 6.184373, -3.159935)",
    ry: 24,
    rx: 24,
    id: "svg_13",
    cy: 352.74949,
    cx: 184.13851,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#00ffff",
    fill: "#000000"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 4.988811, -3.161641)",
    ry: 24,
    rx: 24,
    id: "svg_14",
    cy: 284.24971,
    cx: 183.63851,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#00ffff",
    fill: "#000000"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 3.947457, -3.833969)",
    ry: 24,
    rx: 24,
    id: "svg_15",
    cy: 224.24991,
    cx: 221.63839,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#00ffff",
    fill: "#000000"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 3.644617, -6.131771)",
    ry: 24,
    rx: 24,
    id: "svg_16",
    cy: 205.74996,
    cx: 353.13796,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#00ffff",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 6.694787, -4.64777)",
    ry: 24,
    rx: 24,
    id: "svg_17",
    cy: 381.2494,
    cx: 269.63823,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#000000",
    style: {
      fill: "rgb(182, 3, 86)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 6.644442, -5.878694)",
    ry: 24,
    rx: 24,
    id: "svg_18",
    cy: 377.74941,
    cx: 340.13801,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#000000",
    style: {
      fill: "rgb(255, 5, 83)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 5.532365, -6.446917)",
    ry: 24,
    rx: 24,
    id: "svg_19",
    cy: 313.74962,
    cx: 372.13791,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#000000",
    style: {
      fill: "rgb(255, 60, 0)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 4.531945, -5.809861)",
    ry: 24,
    rx: 24,
    id: "svg_20",
    cy: 256.7498,
    cx: 335.13802,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#000000",
    style: {
      fill: "rgb(255, 216, 0)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 4.564991, -4.596542)",
    ry: 24,
    rx: 24,
    id: "svg_21",
    cy: 259.2498,
    cx: 265.63825,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#000000",
    style: {
      fill: "rgb(0, 128, 8)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999848, 0.017452, -0.017452, 0.999848, 5.606878, -3.985298)",
    ry: 24,
    rx: 24,
    id: "svg_22",
    cy: 319.2496,
    cx: 231.13836,
    opacity: "undefined",
    strokeDasharray: "5,2,2,2,2,2",
    strokeWidth: 0,
    stroke: "#000000",
    style: {
      fill: "rgb(0, 122, 221)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosky);
export default __webpack_public_path__ + "static/media/logosky.970688ff16574e0ccbd2ed35ae1c7263.svg";
export { ForwardRef as ReactComponent };